import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';
import { DeliverClothesModel } from '../model/deliverClothesModel';

@Injectable({
  providedIn: 'root'
})
export class DeliverClothesService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  findInfoEmploye(cedula: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.deliver.url + 
        this.diccionarioUrl.deliver.findInfoEmploye + '/' + cedula);
  }

  findSizeClothes(codBaan: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.deliver.url + 
        this.diccionarioUrl.deliver.findSizeClothes + '/' + codBaan);
  }

  createDeliverClothes(cedula: string, registros: DeliverClothesModel[]){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.deliver.url + '/' + cedula, registros);
  }

}